export default "__VITE_ASSET__DLlpcYmv__"